interface DataLayer extends Array<object> {
  push(...items: object[]): number
}

declare global {
  interface Window {
    dataLayer: DataLayer
  }
}

export const sendDatalayerEvent = (data: Record<string, unknown>) => {
  const dataLayer =
    typeof window !== 'undefined'
      ? (window.dataLayer = window.dataLayer ?? [])
      : // Dummy array on the server to make our code simpler
        []

  dataLayer.push(data)
}
